"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrcadCaptureFontMetrics = void 0;
var OrcadCaptureFontMetrics;
(function (OrcadCaptureFontMetrics) {
    let AdvanceMissReason;
    (function (AdvanceMissReason) {
        AdvanceMissReason["UnknownFont"] = "unknown_font";
        AdvanceMissReason["UnsolvedFont"] = "unsolved_font";
        AdvanceMissReason["UnobservedGlyph"] = "unobserved_glyph";
        AdvanceMissReason["UnresolvedGlyphPair"] = "unresolved_glyph_pair";
    })(AdvanceMissReason = OrcadCaptureFontMetrics.AdvanceMissReason || (OrcadCaptureFontMetrics.AdvanceMissReason = {}));
    const STROKE_HEIGHT_8_GLYPHS = new Map([
        ['0', 4],
        ['1', 4],
        ['2', 4],
        ['3', 4],
        ['4', 4],
        ['5', 4],
        ['6', 4],
        ['7', 4],
        ['8', 4],
        ['9', 4],
        ['#', 4],
        ['+', 4],
        [',', 2],
        ['-', 2],
        ['.', 2],
        ['A', 5],
        ['B', 5],
        ['C', 5],
        ['D', 5],
        ['E', 5],
        ['F', 4],
        ['G', 5],
        ['H', 5],
        ['I', 2],
        ['K', 5],
        ['L', 4],
        ['M', 5],
        ['N', 5],
        ['O', 5],
        ['P', 5],
        ['Q', 5],
        ['R', 5],
        ['S', 5],
        ['T', 5],
        ['U', 5],
        ['V', 5],
        ['W', 7],
        ['X', 5],
        ['^', 3],
        ['_', 4],
    ]);
    const STROKE_HEIGHT_8_TIED_PAIRS = [
        { first: '[', second: ']', pairAdvance: 4 },
        { first: 'i', second: 'n', pairAdvance: 6 },
    ];
    const STROKE_HEIGHT_MINUS_9_GLYPHS = new Map([
        ['0', 5],
        ['1', 5],
        ['2', 5],
        ['3', 5],
        ['4', 5],
        ['5', 5],
        ['6', 5],
        ['7', 5],
        ['8', 5],
        ['9', 5],
        [',', 3],
        ['B', 6],
    ]);
    const STROKE_HEIGHT_8 = { Name: '', Height: 8, Width: 3, Weight: 400, Italic: 0 };
    const STROKE_HEIGHT_MINUS_9 = { Name: '', Height: -9, Width: 4, Weight: 400, Italic: 0 };
    const ROWS = new Map([
        [rowKey(STROKE_HEIGHT_8), { base: 20, glyphs: STROKE_HEIGHT_8_GLYPHS, tiedPairs: STROKE_HEIGHT_8_TIED_PAIRS }],
        [rowKey(STROKE_HEIGHT_MINUS_9), { glyphs: STROKE_HEIGHT_MINUS_9_GLYPHS, tiedPairs: [] }],
    ]);
    const SAMPLED_FAMILIES = new Set([familyKey(STROKE_HEIGHT_8), familyKey(STROKE_HEIGHT_MINUS_9)]);
    function rowKey(font) {
        return `${font.Name}\0${font.Height}\0${font.Width}\0${font.Weight}\0${font.Italic}`;
    }
    function familyKey(font) {
        return `${font.Name}\0${font.Height}`;
    }
    function tiedGlyphAdvance(text, tiedPairs) {
        let total = 0;
        for (const pair of tiedPairs) {
            let firstCount = 0;
            let secondCount = 0;
            for (const glyph of text) {
                if (glyph === pair.first) {
                    firstCount += 1;
                }
                else if (glyph === pair.second) {
                    secondCount += 1;
                }
            }
            if (firstCount !== secondCount) {
                return { unbalancedGlyph: firstCount > secondCount ? pair.first : pair.second };
            }
            total += firstCount * pair.pairAdvance;
        }
        return { advance: total };
    }
    function measure(text, font) {
        const row = ROWS.get(rowKey(font));
        if (!row) {
            return {
                miss: {
                    reason: SAMPLED_FAMILIES.has(familyKey(font)) ? AdvanceMissReason.UnsolvedFont : AdvanceMissReason.UnknownFont,
                },
            };
        }
        if (row.base === undefined) {
            return { miss: { reason: AdvanceMissReason.UnsolvedFont } };
        }
        const tied = tiedGlyphAdvance(text, row.tiedPairs);
        if (tied.advance === undefined) {
            return { miss: { reason: AdvanceMissReason.UnresolvedGlyphPair, glyph: tied.unbalancedGlyph } };
        }
        let total = row.base + tied.advance;
        for (const glyph of text) {
            if (row.tiedPairs.some((pair) => pair.first === glyph || pair.second === glyph)) {
                continue;
            }
            const glyphAdvance = row.glyphs.get(glyph);
            if (glyphAdvance === undefined) {
                return { miss: { reason: AdvanceMissReason.UnobservedGlyph, glyph } };
            }
            total += glyphAdvance;
        }
        return { advance: total };
    }
    OrcadCaptureFontMetrics.measure = measure;
    function advance(text, font) {
        return measure(text, font).advance;
    }
    OrcadCaptureFontMetrics.advance = advance;
    function describeFont(font) {
        return `font "${font.Name}" height ${font.Height} width ${font.Width} weight ${font.Weight} italic ${font.Italic}`;
    }
    OrcadCaptureFontMetrics.describeFont = describeFont;
})(OrcadCaptureFontMetrics || (exports.OrcadCaptureFontMetrics = OrcadCaptureFontMetrics = {}));
//# sourceMappingURL=OrcadCaptureFontMetrics.js.map